import React from 'react';
import { useContext } from 'react';

import TrainWeeklySchedule from '../../components/TrainWeeklySchedule';
import { StationDetails, TrainInfoDetail } from '../../types';
import TrainInfoContext from '../TrainInfoContext';
import { crawlerDuplicateAvoidStyle } from '../../../utils/commonUtils';
import { trackClickEventProp61 } from '../../../utils/omnitureUtils';
import { SEO_TRAIN_PAGE } from '../../../utils/RailsSEOConstants';

type TrainDetailsProps = {
  trainInfo: TrainInfoDetail;
  onClick: (filterData, isMobile) => void;
  sourceStation: StationDetails;
  destinationStation: StationDetails;
  title: string;
  alternatePageUrl: {
    title: string;
    pageUrl: string;
  };
};

export default function TrainDetails({
  trainInfo,
  onClick,
  sourceStation,
  destinationStation,
  title,
  alternatePageUrl
}: TrainDetailsProps) {
  const isMobile = () => window && window.innerWidth < 767;
  const trainsData = useContext(TrainInfoContext);
  return (
    <section>
      <div className="navigationUrl">
        <h3 className="railSeoWrap__railDetails--title desktopShow capText">{title}</h3>
        <p className="trainUrl">
          <a
            href={alternatePageUrl.pageUrl}
            onClick={() => trackClickEventProp61(SEO_TRAIN_PAGE, 'rail_seo_train_switch_hindi')}
          >
            {alternatePageUrl.title}
          </a>
        </p>
      </div>
      <div className="railSeoWrap__railDetails">
        <h3 style={crawlerDuplicateAvoidStyle} className="railSeoWrap__railDetails--title mobileShow">
          {title}
        </h3>
        <div>
          <span>{trainsData.trainInfo['column']['trainCode']}</span>
          <span>#{trainInfo.trainNumber}</span>
        </div>
        <div>
          <span>{trainsData.trainInfo['column']['serviceDays']}</span>
          <TrainWeeklySchedule trainSchedule={trainInfo.trainWeeklySchedule} />
        </div>
        <div>
          <span>{trainsData.trainInfo['column']['trainType']}</span>
          <span>{trainInfo.trainType.join(', ')}</span>
        </div>
        <div>
          <span>{trainsData.trainInfo['column']['classes']}</span>
          <span>{trainInfo.avlClasses.join(', ')}</span>
        </div>
        <div>
          <span>{trainsData.trainInfo['column']['duration']}</span>
          <span>{trainInfo.duration}</span>
        </div>
        <div>
          <span>{trainsData.trainInfo['column']['distance']}</span>
          <span>{trainInfo.distance}</span>
        </div>
        <div>
          <span>{trainsData.trainInfo['column']['stops']}</span>
          <span>{trainInfo.stops}</span>
        </div>
        <div className="railSeoWrap__railDetails--btnCtn">
          <button
            className="primaryBtn"
            onClick={() =>
              onClick(
                {
                  sourceCityEn: sourceStation.cityEn,
                  destinationCityEn: destinationStation.cityEn,
                  sourceCity: sourceStation.city,
                  sourceStn: sourceStation.stationCode,
                  destinationCity: destinationStation.city,
                  destinationStn: destinationStation.stationCode
                },
                isMobile()
              )
            }
          >
            {trainsData.miscellaneous['BOOK TRAIN']}
          </button>
        </div>
      </div>
    </section>
  );
}
